<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import InputGroup from './internal/InputGroup.vue'
import InputGroupAddon from './internal/InputGroupAddon.vue'
import InputGroupInput from './internal/InputGroupInput.vue'
import { useVModel } from '@vueuse/core'

defineOptions({
    compatConfig: {
        MODE: 3,
    },
    inheritAttrs: false,
})

const props = defineProps<{
    defaultValue?: string | number
    modelValue?: string | number
    class?: HTMLAttributes['class']
    inputClass?: HTMLAttributes['class']
    inputStyle?: HTMLAttributes['style']
    required?: boolean
    invalid?: boolean
    disabled?: boolean
}>()

const emits = defineEmits<{
    'update:modelValue': [payload: string | number]
}>()

const modelValue = useVModel(props, 'modelValue', emits, {
    passive: true,
    defaultValue: props.defaultValue,
})
</script>

<template>
    <InputGroup
        :class="props.class"
        :data-disabled="props.disabled"
    >
        <template
            v-if="$slots.prefix"
        >
            <InputGroupAddon>
                <slot name="prefix"></slot>
            </InputGroupAddon>
        </template>
        <InputGroupInput
            v-model="modelValue"
            :class="props.inputClass"
            :style="props.inputStyle"
            :required="props.required"
            :invalid="props.invalid"
            :disabled="props.disabled"
            v-bind="$attrs"
        />
        <template
            v-if="$slots.suffix"
        >
            <InputGroupAddon align="inline-end">
                <slot name="suffix"></slot>
            </InputGroupAddon>
        </template>
    </InputGroup>
</template>
